import { useRef, useState } from "react";
import { useVisibleVideo } from "../hooks/useVisibleVideo";

export const BrandMedia = ({ media, id, eager = false }) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  useVisibleVideo(videoRef, `${media.src}|${media.webm}|${media.preferMp4}`);

  const syncMobileFocus = (event) => {
    const video = event.currentTarget;
    const focus = [...media.mobileFocus].reverse().find(({ from }) => video.currentTime >= from);
    if (focus) video.style.setProperty("--mobile-media-position", focus.position);
  };

  if (media.type === "pending") {
    return (
      <div className="about-immersive-media brand-media" data-testid={`${id}-media`}>
        <span className="brand-media-pending" aria-label={media.alt} data-testid={`${id}-video-pending`}>Video pending</span>
      </div>
    );
  }

  return (
    <div className="about-immersive-media brand-media" data-testid={`${id}-media`}>
      {!imageFailed && (
        <img
          src={media.type === "image" ? media.src : media.poster}
          alt={media.alt}
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          onError={() => setImageFailed(true)}
          data-testid={`${id}-image`}
        />
      )}
      {media.type === "video" && (
        <video
          ref={videoRef}
          poster={media.poster}
          muted loop playsInline preload={media.preload || "none"}
          aria-label={media.alt}
          onPlaying={() => setPlaying(true)}
          onError={() => setPlaying(false)}
          onTimeUpdate={media.mobileFocus ? syncMobileFocus : undefined}
          data-playing={playing}
          data-testid={`${id}-video`}
        >
          {media.preferMp4 && <source src={media.src} type="video/mp4" />}
          {media.webm && <source src={media.webm} type="video/webm" />}
          {!media.preferMp4 && <source src={media.src} type="video/mp4" />}
        </video>
      )}
      {imageFailed && !playing && (
        <span className="brand-media-pending" data-testid={`${id}-media-pending`}>Media pending</span>
      )}
    </div>
  );
};